import {
	ConfigService,
	StateService
} from '../../';

export class HeaderState {
	public back			= ''
	public backData	= {}
	public image		= ''
	public label		= ''

	constructor(private state: StateService) {}

	update(state: string, data: any): HeaderState {
    if (this.state.mobile) {
      if (this.state.isSubPageState(state)) {
        this.back			= state === 'more' || state === 'iab' ? 'map' : 'more',
        this.backData	= (state !== 'more' && state !== 'iab') ? { label: 'More' } : {},
        this.image		= data.image || '',
        this.label		= data.label || ''
      } else {
        this.back			= ''
        this.backData	= {}
        this.image		= ''
        this.label		= ''
      }
    }

		return this
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/state/headerState.ts